var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 10,
    viewBox: "0 0 19 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.59 6l-2.3 2.294A1 1 0 0 0 13 10a1 1 0 0 0 .71-.292l4-4a1 1 0 0 0 0-1.413l-4-4a1.002 1.002 0 1 0-1.42 1.414L14.588 4H1.003a1 1 0 0 0 0 2H14.59z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointArrowRight);
export default __webpack_public_path__ + "static/media/point-arrow-right.a6c619a663f256857c83a0c4b44432d6.svg";
export { ForwardRef as ReactComponent };